import { useState } from 'react'

import { Separator } from '@/components/separator/separator'
import { Tabs, TabsList, TabsTrigger } from '@/components/tabs/tabs'

import { cn } from '@/lib/utils'

import { DASHBOARD_TABS, DASHBOARD_TAB_VALUE } from './constants'
import { CaseUpdates } from './ui/case-updates/case-updates'
import { GeneralInfo } from './ui/general-info/general-info'

export const DashboardUpdatesPage = () => {
  const [currentTab, setCurrentTab] = useState<DASHBOARD_TAB_VALUE>(DASHBOARD_TAB_VALUE.caseUpdates)

  const handleChangeCurrentTab = (value: string) => {
    setCurrentTab(value)
  }

  return (
    <div className={cn('px-10 pb-28 pt-11')}>
      <div className={cn('text-2xl font-bold')}>Dashboard</div>

      <Separator className={cn('my-6')} />

      <Tabs value={currentTab} className={cn('mt-6')} onValueChange={handleChangeCurrentTab}>
        <TabsList>
          {DASHBOARD_TABS.map(({ value, label }) => {
            return (
              <TabsTrigger key={value} value={String(value)}>
                {label}
              </TabsTrigger>
            )
          })}
        </TabsList>
      </Tabs>

      <div className={cn('my-5')}>
        {currentTab === DASHBOARD_TAB_VALUE.caseUpdates && <CaseUpdates />}
        {currentTab === DASHBOARD_TAB_VALUE.generalInfo && <GeneralInfo />}
      </div>
    </div>
  )
}
